'use client';

import React from 'react';
import Link from 'next/link';
import styles from './Level2EmptyState.module.scss';

interface Level2EmptyStateProps {
  message?: string;
  icon?: string;
  ctaButton?: {
    text: string;
    href: string;
  };
  className?: string;
}

export function Level2EmptyState({
  message = 'コンテンツは準備中です。',
  icon = '📋',
  ctaButton,
  className
}: Level2EmptyStateProps) {
  return (
    <div className={`${styles.emptyState} ${className || ''}`}>
      <div className={styles.emptyIcon}>{icon}</div>
      <p className={styles.emptyMessage}>{message}</p>
      {ctaButton && (
        <Link href={ctaButton.href} className={styles.emptyCtaButton}>
          {ctaButton.text}
        </Link>
      )}
    </div>
  );
}

export default Level2EmptyState;